/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendGetProjectDto } from '../../models/backend-get-project-dto';
import { BackendGetProjectRequestDto } from '../../models/backend-get-project-request-dto';

export interface ProjectsProjectCopyCreate$FormData$Params {
  id: number;
  body?: BackendGetProjectRequestDto;
}

export function projectsProjectCopyCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsProjectCopyCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendGetProjectDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectCopyCreate$FormData.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendGetProjectDto>;
    }),
  );
}

projectsProjectCopyCreate$FormData.PATH = '/api/projects/project/copy/{id}/';
